import { Reducer } from "redux";
import { createReducer, ActionType } from "typesafe-actions";

import { IAuthState } from "./types";
import * as UserActions from "./actions";
import { ILoginResponse } from "app/services/default";
import { createIAsyncState, IAsyncStateCreators } from "app/core/redux";

type UserAction = ActionType<typeof UserActions>;

const asyncCreator: IAsyncStateCreators = {
    login: createIAsyncState<ILoginResponse>({ token: "" })
};

const initialState: IAuthState = {
    isAuthenticated: false,
    login: asyncCreator.login.initial()
};

const userReducer: Reducer<IAuthState, UserAction> = createReducer<IAuthState>(initialState)
    .handleAction(UserActions.loginAsync.request,
        (state: IAuthState) => ({ ...state, isAuthenticated: false, login: asyncCreator.login.requesting() }))
    .handleAction(UserActions.loginAsync.success,
        (state: IAuthState, action: any) => ({ ...state, isAuthenticated: true, login: asyncCreator.login.success(action.payload) }))
    .handleAction(UserActions.loginAsync.failure,
        (state: IAuthState, action: any) => ({ ...state, isAuthenticated: false, login: asyncCreator.login.failure(action.error) }));

export default userReducer;
